<template>
  <modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal">
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form-without-modal ref="newProductForm" :table-id="tableId" :form-id="formId" :row-data="modalValue"
        :selected-url="selectedUrl" :on-after-submit="closeModal" />
    </template>
  </modal>
</template>

<script>
import FormWithoutModal from "./FormWithoutModal";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
  name: "ModalForm",
  components: { FormWithoutModal },
  mixins: [ModalMixin],
  props: {
    tableId: String,
    formId: String,
    value: {
      type: Object,
      default: () => {
        return {
          product_category_id: undefined,
          code: "",
          name: "",
          is_active: "",
          product_category: {
            id: undefined,
            code: "",
            name: "",
            is_active: "",
          },
          center_id: {
            id: undefined,
            name: "",
            is_active: "",
          },
        };
      },
    },
    selectedUrl: String,
  },
  data() {
    return {
      modalId: this.formId,
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
    }
  },
  mounted() {
    this.observeLoadMoreButton();
    const observer = new MutationObserver(() => {
      this.observeLoadMoreButton();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  },
  computed: {
    modalValue: {
      get() { return this.value; },
      set(newVal) { this.$emit('input', newVal); },
    },
  },
  methods: {
    submit() {
      this.$refs.newProductForm.submit();
    },
    observeLoadMoreButton() {
      setTimeout(() => {
        const dropdowns = document.querySelectorAll(
          ".dropdown-search-result-wrapper"
        );

        dropdowns.forEach((dropdown) => {
          // Hapus event lama untuk mencegah duplikasi
          dropdown.removeEventListener("scroll", this.handleScroll);
          dropdown.addEventListener("scroll", this.handleScroll);
        });
      }, 500);
    },
  },
};
</script>
